// session-expired-dialog.component.ts
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
    standalone: true,
    selector: 'app-session-expired-dialog',
    imports: [CommonModule, MatDialogModule, MatButtonModule],
    template: `
    <div class="dialog-container">
      <h2 class="title">Session Expired</h2>
      <p class="message">Your session has expired. Please log in again.</p>
      <button mat-flat-button color="primary" (click)="onConfirm()">OK</button>
    </div>
  `,
    styles: [`
    .dialog-container {
      text-align: center;
      padding: 24px;
      min-width: 300px;
    }
    .title {
      font-size: 20px;
      margin-bottom: 10px;
      color: #d32f2f;
    }
    .message {
      font-size: 16px;
      margin-bottom: 20px;
    }
    button {
      width: 100px;
    }
  `]
})
export class SessionExpiredDialogComponent {
    constructor(private dialogRef: MatDialogRef<SessionExpiredDialogComponent>) { }

    onConfirm() {
        this.dialogRef.close(true);
    }
}
